<template>
  <div class="ts-space-y-3">
    <div class="row">
      <label class="col-md-4 col-form-label ts-text-xs required ts-font-light">
        {{ $t('productPriceSchema.tableType') }}
      </label>
      <div class="col-md-7">
        <a-select v-model="model.guest_level_id" :options="guestLevels" show-search option-filter-prop="children"
          class="ts-w-full" :class="{ 'is-invalid': errors.has('guest_level_id') }" placeholder="Select"
          disabled></a-select>
        <div class="validate ts-text-xs" v-if="errors.has('guest_level_id')">
          {{ errors.first('guest_level_id') }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-md-4 col-form-label ts-text-xs required ts-font-light">
        {{ $t('productPriceSchema.incrementType') }}
      </label>
      <div class="col-md-7">
        <a-select v-model="model.increment_type" :options="incrementTypes" class="ts-w-full"
          :class="{ 'is-invalid': errors.has('increment_type') }" placeholder="Select"></a-select>
        <div class="validate ts-text-xs" v-if="errors.has('increment_type')">
          {{ errors.first('increment_type') }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-md-4 col-form-label ts-text-xs required ts-font-light">
        {{ $t('productPriceSchema.incrementAmount') }}
      </label>
      <div class="col-md-7">
        <input v-model="model.increment_amount" type="number" class="form-control" style="height: 32px;" />
        <div class="validate ts-text-xs" v-if="errors.has('increment_amount')">
          {{ errors.first('increment_amount') }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-md-4 col-form-label ts-text-xs required ts-font-light">
        {{ $t('productPriceSchema.maxPersons') }}
      </label>
      <div class="col-md-7">
        <input v-model="model.max_person" type="number" class="form-control" style="height: 32px;" />
        <div class="validate ts-text-xs" v-if="errors.has('max_person')">
          {{ errors.first('max_person') }}
        </div>
      </div>
    </div>
    <div class="row">
      <label class="col-md-4 col-form-label ts-text-xs required ts-font-light">
        {{ $t('productPriceSchema.serviceLength') }}
      </label>
      <div class="col-md-7">
        <input v-model="model.service_length" type="number" class="form-control" style="height: 32px;" />
        <div class="validate ts-text-xs" v-if="errors.has('service_length')">
          {{ errors.first('service_length') }}
        </div>
      </div>
    </div>
    <div slot="footer">
      <div class="ts-flex ts-justify-end ts-space-x-2 ts-sh mt-3">
        <ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button color="primary" @click.prevent="onUpdate" :waiting="waiting">
          {{ $t('update') }}</ts-button>
      </div>
    </div>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { isEmpty } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'product-price-schema-edit',
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      model: {
        guest_level_id: null,
        increment_type: null,
        increment_amount: null,
        max_person: null,
        service_length: null,
      }
    }
  },
  created() {
    this.getPreData()
    this.setEditData()
  },
  computed: {
    ...mapState('restaurantSale/productPriceSchema', ['edit_data', 'formViewDatas']),
    guestLevels() {
      if (this.formViewDatas['guestLevels']) {
        return this.formViewDatas['guestLevels'].map(el => ({
          value: el.id,
          label: el.guest_level_name_en
        }))
      }
      return []
    },
    incrementTypes() {
      return [
        {
          value: '%',
          label: '%'
        },
        {
          value: this.$store.state.authUser.sys_setting.default_currency_sign,
          label: this.$store.state.authUser.sys_setting.default_currency_sign
        },
      ]
    },
  },
  methods: {
    ...mapActions('restaurantSale/productPriceSchema', ['getFormViewModel']),
    async getPreData() {
      this.loading = true
      await this.getFormViewModel({ index: undefined, params: {} })
      this.loading = false
    },
    onUpdate() {
      this.waiting = true
      this.$store
        .dispatch('restaurantSale/productPriceSchema/update', {
          id: this.edit_data.id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    async setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.guest_level_id = this.edit_data.guest_level_id
        this.model.increment_type = this.edit_data.increment_type
        this.model.increment_amount = this.edit_data.increment_amount
        this.model.max_person = this.edit_data.max_person
        this.model.service_length = this.edit_data.service_length
      }
    },
    clearInput() {
      this.model.guest_level_id = null
      this.model.increment_type = null
      this.model.increment_amount = null
      this.model.max_person = null
      this.model.service_length = null
    }
  },
}
</script>
